import { useCallback, useMemo } from 'react';
import { Icon, Modal, Paragraph } from 'ui';

type P = {
  onRequestUnblockAccount: (email?: string) => void;
};

export const useShowLockedAccountModal = () => {
  const [modal, contextHolder] = Modal.useModal();

  const showUnblockAccountModal = useCallback(
    ({ onRequestUnblockAccount }: P) => {
      modal.confirm({
        content: (
          <>
            <Paragraph>
              Your account has been locked for 30 minutes after 5 failed attempts to login. After this period, your
              account will be available with current credentials.
            </Paragraph>
            <Paragraph>If you wish to unlock your account sooner, you need to reset your password.</Paragraph>
          </>
        ),
        icon: <Icon color="error" icon="delete-2-line" />,
        okText: 'Reset password',
        onOk() {
          onRequestUnblockAccount();
        },
        title: 'Authentication failed',
      });
    },
    [modal],
  );

  return useMemo(() => ({ contextHolder, showUnblockAccountModal }), [showUnblockAccountModal, contextHolder]);
};
